import * as React from 'react'
import { RenderElementProps } from 'slate-react'
import { HeadingElement } from '../slate'

const Header1Element = ({
  isOrdered,
  attributes,
  children
}: RenderElementProps & Pick<HeadingElement, 'isOrdered'>) => {
  return (
    <h1 {...attributes} className={isOrdered ? 'ordered' : ``}>
      {children}
    </h1>
  )
}

export default Header1Element
